import { render, staticRenderFns } from "./StatHospitalListComponent.vue?vue&type=template&id=267bb571&"
import script from "./StatHospitalListComponent.vue?vue&type=script&lang=js&"
export * from "./StatHospitalListComponent.vue?vue&type=script&lang=js&"
import style0 from "./StatHospitalListComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports